export function getV2Api() {
    return process.env.REACT_APP_V2_API_URL || 'https://api.v2.pickuphungary.com/';
}